import { all, fork } from 'redux-saga/effects'

import authSaga from './auth/sagas'
import patientSaga from './patient/sagas'
import followUp from './followUp/sagas'
import users from './users/sagas'
import alertSaga from './alert/sagas'
import reportSaga from './report/sagas'
import activeSearchSaga from './active.search/sagas'
import ongSaga from './ngo/sagas'
import relevanceSaga from './relevance/sagas'

export default function* rootSaga() {
    return yield all([
        fork(authSaga),
        fork(patientSaga),
        fork(followUp),
        fork(users),
        fork(alertSaga),
        fork(reportSaga),
        fork(activeSearchSaga),
        fork(ongSaga),
        fork(relevanceSaga)
    ])
}
